<template>
    <PopupRouterView :showLeftIcon="true" label="Bill Of Material Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="billofmaterial"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="billOfMaterialInput">


        <b-card header="Bill Of Material" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" 
							label-cols-lg="12" label="Part Number" id="fieldset-part-number" size="sm" 
							:model.sync="model.partNumberId" :isRequired="true" :state="validateState('partNumberId')" 
							:errorMessage="getErrorMessage(errorMessage.partNumberId, 'partNumberId')"   
							:selected="model.partNumber != null ? model.partNumber.partNumber : ''" 
							@input="getParts" @change="updateDataDetails"  :isSelectMethodExists="true" 
							@onSelectMethod="setSelectedPartNumber" />
						<app-label label-cols-lg="12" size="sm" label="Part Name" :model="(model.partNumber != null) ? model.partNumber.partName : null"  />
						<app-label label-cols-lg="12" size="sm" label="Customer" :model="(model.partNumber != null) ? (model.partNumber.customer != null) ? model.partNumber.customer.code : null : null"  />
					</b-col>
					<b-col cols="12" lg="6">
						<app-label label-cols-lg="12" size="sm" label="Part Classification" :model="(model.partNumber != null) ? (model.partNumber.partClassification != null) ? model.partNumber.partClassification.code : null : null"  />
				</b-col>

            </b-row>
        </b-card>

		<app-table-input 
			title = "Bill Of Material Detail"
			:bordered="true" :items="billOfMaterialDetails" 
			:fields="fieldsBillOfMaterialDetail" 
			:busy="isDataLoading" 
			:sort-by.sync="sortByBillOfMaterialDetail" 
			:sort-desc.sync="sortDescBillOfMaterialDetail" small responsive	
			@editButtonMethod="editRowDataBillOfMaterialDetail"	
			@deleteButtonMethod="deleteRowDataBillOfMaterialDetail"	
			@showPopupAddMethod="addDataBillOfMaterialDetail()"	
			@showPopupUploadMethod="showPopupUploadBillOfMaterialDetail()"
			@downloadMethod="downloadBillOfMaterialDetail()"
			@addFromClipboardMethod="addFromClipboardBillOfMaterialDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardBillOfMaterialDetail()"
			:showActionButton="true"
			:showDeleteButton="true"
			:showAddButton="true"
			:showAddFromClipboardButton="false"	
			:showReplaceFromClipboardButton="false"	
			:showUploadButton="false"	
			:showDownloadButton="false"	
			:isDownloadBusy="isDownloadBillOfMaterialDetail"
		>
								
			<!-- <template v-slot:head(actions)>
				<b-button @click="isShowBillOfMaterialDetailFilter = !isShowBillOfMaterialDetailFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
			</template> -->
								
			<template #top-row v-if="isShowBillOfMaterialDetailFilter">
				<b-th></b-th>
				<b-th stacked-heading="Part Number">
					<v-select id="input-bill-of-material-detail-part-number-table" append-to-body label="partNumber" :options="parts" :value="filterBillOfMaterialDetail.partNumberId" :reduce="item => item.id" v-model="filterBillOfMaterialDetail.partNumberId" @search="getParts" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Used Qty">
					<b-form-input id="input-bill-of-material-detail-used-qty-table" v-model="filterBillOfMaterialDetail.usedQty" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Part Price">
					<v-select id="input-bill-of-material-detail-part-price-table" append-to-body label="part" :options="partPrices" :value="filterBillOfMaterialDetail.partPriceId" :reduce="item => item.id" v-model="filterBillOfMaterialDetail.partPriceId" @search="getPartPrices" :filterable ="true"></v-select>
				</b-th>

				<b-th></b-th>
			</template>
								
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( billOfMaterialDetailPageSize * (currentBillOfMaterialDetailPage - 1))) }}
			</template>
								
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
								
			<template v-slot:cell(partNumber)="row">
				<app-input-combobox-autocomplete :options="partDetails" optionsLabel="partNumber" optionsKey="id" 
				:id="'input-bill-of-material-detail-part-number-' + row.index" label-cols-lg="12" label="Part Number" size="sm" 
				:model.sync="row.item.partNumberId" :state="validateState('partNumberId')" 
				:errorMessage="getErrorMessage(errorMessage.partNumberId, 'partNumberId')"  @change="onChangePart(row.item)" 
				:selected="row.item.partNumber != null ? row.item.partNumber.partNumber : ''"  @input="getPartForDetail" 
				:loading="isPartComboLoading"  :nolabel="true" />
			</template>
			<template v-slot:cell(partName)="row">
						<app-label label-cols-lg="12" size="sm" label="Part Name" :model="(row.item.partNumber != null) ? row.item.partNumber.partName : null"  />
			</template>
			<template v-slot:cell(usedQty)="row">
				<app-input-textbox :id="'input-bill-of-material-detail-used-qty-' + row.index" label-cols-lg="12" label="Used Qty" size="sm" :model.sync="row.item.usedQty"   @change="saveInputBillOfMaterialDetail(row.item)"   :nolabel="true" />
			</template>
			<template v-slot:cell(uom)="row">
						<app-label label-cols-lg="12" size="sm" label="Uom" :model="(row.item.partNumber != null) ? (row.item.partNumber.uom != null) ? row.item.partNumber.uom.code : null : null"  />
			</template>
			<!-- <template v-slot:cell(partPrice)="row">
				<app-input-combobox-autocomplete :options="partPriceDetail" optionsLabel="partVendor" optionsKey="id" :id="'input-bill-of-material-detail-part-price-' + row.index" label-cols-lg="12" label="Part Price" size="sm" :model.sync="row.item.partPriceId"  @change="saveInputBillOfMaterialDetail(row.item)" :selected="row.item.partPrice != null ? row.item.partPrice.partVendor : ''"  @input="getPartPriceForDetail(row.item)" :reloadData="true" :loading="isPartPriceComboLoading" :nolabel="true" />
			</template>
			<template v-slot:cell(priceProduct)="row">
						<app-label label-cols-lg="12" size="sm" label="Price Product" :model="(row.item.partPrice != null) ? row.item.partPrice.priceProduct : null" :thousandSeparator="true" />
			</template> -->

								
			<template v-slot:form-add-detail>
				<BillOfMaterialDetailInput 
					:model="modelBillOfMaterialDetail"
					:openPopup="isShowPopupBillOfMaterialDetail"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataBillOfMaterialDetail"/>
			</template>
			<template v-slot:upload-detail>
					<BillOfMaterialDetailUpload
					:openPopup="isShowPopupUploadBillOfMaterialDetail"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataBillOfMaterialDetail"
					:parentId="modelId"
					/>
			</template>
			<!-- <template v-slot:table-paging>
				<b-pagination
				class="float-right btn-paging"
				v-model="currentBillOfMaterialDetailPage"
				:total-rows="totalBillOfMaterialDetailRow"
				:per-page="billOfMaterialDetailPageSize"
				aria-controls="my-table"
				></b-pagination>
			</template> -->
		</app-table-input>


        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterView>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import BillOfMaterial from '@/models/BillOfMaterial/BillOfMaterial';
import BillOfMaterialList from '@/models/BillOfMaterial/BillOfMaterialList';
import BillOfMaterialFilter from '@/filters/BillOfMaterial/BillOfMaterialFilter';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppLabel from '@/components/AppLabel';
import BillOfMaterialDetail from '@/models/BillOfMaterial/BillOfMaterialDetail';
import BillOfMaterialDetailFilter from '@/filters/BillOfMaterial/BillOfMaterialDetailFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import PartPrice from '@/models/PartPrice/PartPrice';
import PartPriceFilter from '@/filters/PartPrice/PartPriceFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import BillOfMaterialDetailInput from '@/views/BillOfMaterial/BillOfMaterialDetailInput';
import BillOfMaterialDetailUpload from '@/views/BillOfMaterial/BillOfMaterialDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputComboboxAutocomplete,
		AppLabel,
		AppInputTextbox,
		BillOfMaterialDetailInput,BillOfMaterialDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			partNumberId: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				partNumberId: { required : "Part Number is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsBillOfMaterialDetail: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"partNumber": { "class" : "th-part-number first-child", "label" : "Part Number", key: 'partNumber', sortable: false}}, 
				{"partName": { "class" : "th-part-name", "label" : "Part Name", key: 'partName', sortable: false}}, 
				{"usedQty": { "class" : "th-used-qty last-child", "label" : "Used Qty", key: 'usedQty', sortable: false}}, 
				{"uom": { "class" : "th-uom d-stack-none", "label" : "Uom", key: 'uom', sortable: false}}, 
				// {"partPrice": { "class" : "th-part-price d-stack-none", "label" : "Part Price", key: 'partPrice', sortable: false}}, 
				// {"priceProduct": { "class" : "th-price-product d-stack-none", "label" : "Price Product", key: 'priceProduct', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelBillOfMaterialDetail : {},
			isShowPopupBillOfMaterialDetail : false,
			isShowPopupUploadBillOfMaterialDetail : false,
			filterBillOfMaterial : null,
			currentBillOfMaterialPage : 1,
			billOfMaterialPageSize: 10,
			sortByBillOfMaterial: '',
			sortDescBillOfMaterial: '',
			filterBillOfMaterialDetail : null,
			currentBillOfMaterialDetailPage : 1,
			billOfMaterialDetailPageSize: 10,
			sortByBillOfMaterialDetail: '',
			sortDescBillOfMaterialDetail: '',
			sortingByBillOfMaterialDetail: [],
			billOfMaterialDetails : [],
			billOfMaterialDetailId : '',
			totalBillOfMaterialDetailRow : 0,
			isShowBillOfMaterialDetailFilter: false,
			isDownloadBillOfMaterialDetail: false,
			parts: [],
			partDetails: [],
			partPrices: [],
			partPriceDetail: [],
			listPartPrice: [],
			existBillofMaterial: [],
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isPartComboLoading: false,
			isBillOfMaterialComboLoading: false,
			isPartPriceComboLoading: false,
			oldPartNumberId : '',
			oldPartNumber : {},
		}
	},
	methods : {
		handleFocusSearch(item) {
			this.getPartPriceForDetail(item);
		},
		getBillOfMaterial : async function(id) {
			this.isBusy = true;
			BillOfMaterial.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();

				if(this.model.partNumberId != null) {
					promises.push(
						this.getPart(this.model.partNumberId).then(result => { 
							return true; 
						}).catch(error => {
							this.$store.dispatch('addErrorMessageGlobal', error);
							throw error;
						})
					);
				}

				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadBillOfMaterial = true;
			this.filterBillOfMaterial.id = this.modelId;
			BillOfMaterial.downloadDataDetail(this, this.filterBillOfMaterial).then(result => {
				this.isDownloadBillOfMaterial = false;
			}).catch(error => { this.isDownloadBillOfMaterial = false; })
		},
		getBillOfMaterialDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterBillOfMaterialDetail);
			if (this.modelId == null) return;
			filter.billOfMaterialId = this.modelId;
			// filter.draftMode = "1";
			if (this.sortByBillOfMaterialDetail != null) {
				this.sortingByBillOfMaterialDetail[this.sortByBillOfMaterialDetail] = this.sortDescBillOfMaterialDetail;
			}
			let currentPage = (this.currentBillOfMaterialDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalBillOfMaterialDetailRow + 1;
				let page = Math.ceil(totalData/this.billOfMaterialDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.billOfMaterialDetailPageSize = 0;
			// disable paging end
			BillOfMaterialDetail.getList(this, filter, this.sortingByBillOfMaterialDetail, currentPage , this.billOfMaterialDetailPageSize).then(result => {
				this.currentBillOfMaterialDetailPage = currentPage + 1;
				this.billOfMaterialDetails = result.data;
				this.model.billOfMaterialDetail = this.billOfMaterialDetails;
				this.totalBillOfMaterialDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getBillOfMaterials : async function(input) {
			let filter = new BillOfMaterialFilter();
			if (input != undefined) {
				filter.PartNumber = input;
			}
			this.isBillOfMaterialComboLoading = true;
			BillOfMaterial.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.billOfMaterials = result.data
				}
				this.isBillOfMaterialComboLoading = false;
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			// let filterBom = new BillOfMaterialFilter();
			// await BillOfMaterial.getList(this, filterBom, null, 0, 10)
			// .then(result => {
			// 	if (result != null) {
			// 		this.existBillofMaterial = result.data
			// 	}
			// })
			// .catch(error => {});

			let filter = new PartFilter();
			// filter["idNotEquals"] = this.existBillofMaterial.map(item => item.partNumberId).join(',');
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
				this.isPartComboLoading = false;
			})
			.catch(error => {});
		},
		getPartForDetail : async function(input) {
			if (this.model.partNumberId != null) {
				let filterBom = new BillOfMaterialFilter();
				await BillOfMaterial.getList(this, filterBom, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.existBillofMaterial = result.data
					}
				})
				.catch(error => {});
				
				let filter = new PartFilter();
				let existingIds = this.existBillofMaterial.map(item => item.partNumberId).join(',');
				let modelId = this.model.partNumberId;

				// Combine the values into a single string
				filter["idNotEquals"] = existingIds + (existingIds && modelId ? ',' : '') + modelId;
				if (input != undefined) {
					filter.partNumber = input;
				}
				this.isPartComboLoading = true;
				Part.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.partDetails = result.data
					}
					this.isPartComboLoading = false;
				})
				.catch(error => {});
			}
		},
		getPartPrices : async function(input) {
			let filter = new PartPriceFilter();
			if (input != undefined) {
				filter.part = input;
			}
			this.isPartPriceComboLoading = true;
			PartPrice.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.partPrices = result.data
				}
				this.isPartPriceComboLoading = false;
			})
			.catch(error => {});
		},
		getPartPriceForDetail : async function(item) {
			let filter = new PartPriceFilter();
			filter.partId = item.partNumberId;

			this.isPartPriceComboLoading = true;
			PartPrice.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) { 
					this.listPartPrice = [];
					this.partPriceDetail = [];

					this.listPartPrice = result.data;
					this.listPartPrice.forEach(element => {
						if (element.endDate == null) {
							const dateNow = new Date();
							const startDate = new Date(element.startDate);
							if (dateNow >= startDate) {
								this.partPriceDetail.push(element);
							}
						}else{
							const dateNow = new Date();
							const startDate = new Date(element.startDate);
							const endDate = new Date(element.endDate);
							if (dateNow >= startDate && dateNow <= endDate) {
								this.partPriceDetail.push(element);
							}
						}
					});
				}
				this.isPartPriceComboLoading = false;
			})
			.catch(error => {});
		},
		setSelectedPartNumber(item) {
			if (this.billOfMaterialDetails.length > 0) {
				this.updateDataDetails(item);
			}else{
				if(item == undefined || item == null) {
					this.model.partNumberId = null;
					this.model.partNumber = null;
				} else {
					this.model.partNumberId = item.id;
					this.model.partNumber = item;
				}
				this.oldPartNumberId = item.id;
				this.oldPartNumber = item;
				this.$forceUpdate();
				this.updateData();
			}
		},
		updateDataDetails(item) {
			const msg = this.$createElement;
			let msgNode = '';
			msgNode = msg('div', { domProps: { innerHTML: '<p>Are you sure you want to change the part number? This action will delete the current details.</p>' } })
			this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e=>{
				if(e){
					this.isBusy = true;
					this.billOfMaterialDetails.forEach(element => {
						this.deleteRowDataBillOfMaterialDetail(element.id);
					});

					if(item == undefined || item == null) {
						this.model.partNumberId = null;
						this.model.partNumber = null;
					} else {
						this.model.partNumberId = item.id;
						this.model.partNumber = item;
					}
					this.oldPartNumberId = item.id;
					this.oldPartNumber = item;
					this.$forceUpdate();
					this.updateData();
					this.isBusy = false;
				} else {
					this.model.partNumber = this.oldPartNumber;
					this.model.partNumberId = this.oldPartNumberId;
					return;
				}
			});
		},
		getPart : async function(id) {
			Part.getData(this, id).then(result => {
				this.model.partNumber = result;
				this.isBusy = false;
				return result;
				}).catch(error => { });
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.billOfMaterialInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					BillOfMaterial.updateDataDetail(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'billofmaterialindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					BillOfMaterial.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'billofmaterialindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();
			this.parts = [];
			this.partDetails = [];

			// let itemExist = this.billOfMaterialDetails.find(item => item.partNumberId == model.partNumberId);
			// if (itemExist) {
			// 	itemExist.partNumber = null;
			// 	itemExist.partNumberId = null;
			// 	itemExist.partPrice = null;
			// 	itemExist.partPriceId = null;
			// 	itemExist.usedQty = null;
			// 	this.saveInputBillOfMaterialDetail(itemExist);
			// }

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					BillOfMaterial.updateData(this, model, id)
					.catch((error) => {
						this.getBillOfMaterial(id);
					});
				}
			});
		},
		onHidden() {
			this.getBillOfMaterials();
		},
		addRowDataBillOfMaterialDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.billOfMaterialId =  this.modelId;
					BillOfMaterialDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getBillOfMaterialDetails(true);
						this.isShowPopupBillOfMaterialDetail = false;
					})
				} else {
					model.billOfMaterialId =  this.modelId;
					BillOfMaterialDetail.createDataDetail(this, model)
					.then(result => {
						this.getBillOfMaterialDetails(true);
						this.isShowPopupBillOfMaterialDetail = false;
					})
				}
			}
		},
		async editRowDataBillOfMaterialDetail(id) {
			this.billOfMaterialDetailId = id;
			this.isShowPopupBillOfMaterialDetail = true; 
		},
		async deleteRowDataBillOfMaterialDetail(id) {
			BillOfMaterialDetail.deleteData(this, id).then(result => { this.getBillOfMaterialDetails(); });
		},
		async resetDataBillOfMaterialDetail() {
			this.billOfMaterialDetailId = "";
			this.isShowPopupBillOfMaterialDetail = true;
		},
		async addDataBillOfMaterialDetail() {
			BillOfMaterialDetail.createData(this, { billOfMaterialId: this.modelId })
			.then(result => {
				this.getBillOfMaterialDetails(true);
			})
		},
		async addFromClipboardBillOfMaterialDetail() {
			let partNumbers = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					partNumbers.push({ partNumber: item, billOfMaterialId: this.modelId });
				});
				BillOfMaterialDetail.addFromClipboard(this, partNumbers).then(result => { this.getBillOfMaterialDetails() });
			});
		},
		async replaceFromClipboardBillOfMaterialDetail() {
			let partNumbers = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					partNumbers.push({ partNumber: item, billOfMaterialId: this.modelId });
				});
				BillOfMaterialDetail.replaceFromClipboard(this, partNumbers).then(result => { this.getBillOfMaterialDetails() });
			});   
		},
		showPopupUploadBillOfMaterialDetail() {
			this.isShowPopupUploadBillOfMaterialDetail = true;
		},
		uploadDataBillOfMaterialDetail(modalEvent, newDatas) {
			this.isShowPopupUploadBillOfMaterialDetail = false; 
		},
		downloadBillOfMaterialDetail(modalEvent) {
			this.isDownloadBillOfMaterialDetail = true;
			this.filterBillOfMaterialDetail.billOfMaterialId = this.modelId;
			BillOfMaterialDetail.downloadDataDetail(this, this.filterBillOfMaterialDetail).then(result => {
				this.isDownloadBillOfMaterialDetail = false;
			}).catch(error => { this.isDownloadBillOfMaterialDetail = false; })
		},
		onChangePart(item) {
			this.partPriceDetail = [];
			item.partPrice = null;
			item.partPriceId = null;
			this.saveInputBillOfMaterialDetail(item);
		},
		saveInputBillOfMaterialDetail(item) {
			if (this.billOfMaterials != null && this.billOfMaterials != undefined  && this.billOfMaterials.length > 0) {
				item.billOfMaterial = this.billOfMaterials.find(q => q.id == item.billOfMaterialId);
			}
			if (this.partDetails != null && this.partDetails != undefined  && this.partDetails.length > 0 && this.partDetails.find(q => q.id == item.partNumberId)) {
				item.partNumber = this.partDetails.find(q => q.id == item.partNumberId);
			}
			if (this.partPriceDetail != null && this.partPriceDetail != undefined  && this.partPriceDetail.length > 0) {
				item.partPrice = this.partPriceDetail.find(q => q.id == item.partPriceId);
			}
			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					BillOfMaterialDetail.updateData(this, item, item.id);
					this.model.billOfMaterialDetail = this.billOfMaterialDetails;
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadBillOfMaterialDetail = false; 
			this.isShowPopupBillOfMaterialDetail = false; 
			if (modalType == 'BillOfMaterialDetail') {
				this.getBillOfMaterialDetails();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				//this.isShowBillOfMaterialDetailFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterBillOfMaterial = new BillOfMaterialFilter();
		this.filterBillOfMaterialDetail = new BillOfMaterialDetailFilter();
		//this.getBillOfMaterials();
		//this.getParts();
		//this.getPartPrices();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getBillOfMaterial(id);
			} else {
				this.modelId = id;
				this.getBillOfMaterial(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
	},
	watch : {
		sortByBillOfMaterialDetail : {
			handler: function() {
				this.getBillOfMaterialDetails();
			}
		},
		sortDescBillOfMaterialDetail: {
			handler: function() {
				this.getBillOfMaterialDetails();
			}
		},
		currentBillOfMaterialDetailPage: {
			handler: function() {
				this.getBillOfMaterialDetails();
			}
		},
		billOfMaterialDetailPageSize : {
			handler: function() {
				this.getBillOfMaterialDetails();
			}
		},
		filterBillOfMaterialDetail: {
			handler: function() {
				this.getBillOfMaterialDetails();
			},
			deep: true,
		},
	},
}
</script>
